import { render, staticRenderFns } from "./CursoInduccion.vue?vue&type=template&id=3abed475&scoped=true"
import script from "./CursoInduccion.vue?vue&type=script&lang=js"
export * from "./CursoInduccion.vue?vue&type=script&lang=js"
import style0 from "./CursoInduccion.vue?vue&type=style&index=0&id=3abed475&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abed475",
  null
  
)

export default component.exports